/**
 * API tokens of the evals MCP server (obsessless-api src/routes/evals/adminApiTokens.ts).
 * Only token issuers can call these; anyone else gets `permission-denied`. Like the other
 * eval routes, they exist only where the API has EVALS_ENABLED=true and answer `not-found`
 * elsewhere.
 */
import { createApiCall } from '../../../services/apiClient';
import type { ApiTokenInfo, CreateApiTokenRequest } from '../types/apiTokenTypes';

const createCall = createApiCall<CreateApiTokenRequest, { token: string; tokenInfo: ApiTokenInfo }>('adminCreateApiToken');
const listCall = createApiCall<void, { tokens: ApiTokenInfo[] }>('adminListApiTokens');
const revokeCall = createApiCall<{ tokenId: string }, { tokenInfo: ApiTokenInfo }>('adminRevokeApiToken');

export const apiTokensService = {
  /** Returns the token itself only here; the API keeps only its hash. */
  create: (request: CreateApiTokenRequest): Promise<{ token: string; tokenInfo: ApiTokenInfo }> => createCall(request),

  /** Newest first, revoked and expired tokens included. */
  list: async (): Promise<ApiTokenInfo[]> => (await listCall(undefined)).tokens,

  revoke: async (tokenId: string): Promise<ApiTokenInfo> => (await revokeCall({ tokenId })).tokenInfo,
};
